import React from "react";

const getCouponStatus = ({ addingType }) =>
  ({ USER: "Purchased", ADMIN: "Added" }[addingType] || null);

export default getCouponStatus;
